import React, {PropTypes}                   from 'react';
import { envCheck }                         from 'utils/util';

require('classlist');
export default React.createClass({
  displayName: 'MedscapeTV.Comments',
  propTypes: {
   videoUrlFragment: PropTypes.string.isRequired
  },
  getDefaultProps: function() {
    return {
      videoUrlFragment: ''
    };
  },
  componentDidMount() {
    document.getElementById('livefyre_iframe').setAttribute('src', `http://www${envCheck()}.medscape.com/mtv/${window.MedscapeTVInstance.seriesUrlFragment}/mtvc-${this.props.videoUrlFragment}`);
  },
  shouldComponentUpdate(nextProps) {
    return (this.props.videoUrlFragment !== nextProps.videoUrlFragment);
  },
  componentDidUpdate() {
    document.getElementById('livefyre_iframe').setAttribute('src', `http://www${envCheck()}.medscape.com/mtv/${window.MedscapeTVInstance.seriesUrlFragment}/mtvc-${this.props.videoUrlFragment}`);
  },
  render() {
    return (
      <div></div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv/comments.jsx
 **/